import { render, staticRenderFns } from "./DmmCustomFields.vue?vue&type=template&id=dc2ba3c4"
import script from "./DmmCustomFields.vue?vue&type=script&lang=js"
export * from "./DmmCustomFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports